import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Paper from 'material-ui/Paper'
import moment from 'moment'
import Constants from '../../../utils/CommonConstants'

if (process.env.WEBPACK) {
  require('./DashboardGrid.css')
}
const cardStyle = {
  height: 200,
  width: 200,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
  padding: 5
}

const linkStyle = {
  textDecoration: 'none'
}

export default class DashboardGrid extends Component {
  static getUrlFromKey(dashboardType, name, params) {
    return `/list/${dashboardType}/${name.toLowerCase()}${params ? `?${params}` : ''}`
  }

  static parseTitle(name) {
    return name
      .replace(new RegExp('_', 'g'), ' ')
      .toLowerCase()
      .replace(/\b[a-z]/g, letter => {
        return letter.toUpperCase()
      })
  }

  static getQueryParams(startDate, endDate) {
    const params = []
    if (startDate) {
      params.push(`startDate=${moment(startDate).startOf('day').valueOf()}`)
    }
    if (endDate) {
      params.push(`endDate=${moment(endDate).endOf('day').valueOf()}`)
    }
    if (params.length === 0) return ''
    return params.join('&')
  }

  static getSingleGrid(dashboard, key) {
    const dashboardEntities = Constants.dashboardEntities
    const label = dashboardEntities[key].name || DashboardGrid.parseTitle(key)
    return (
      <Paper style={cardStyle} zDepth={1} key={key}>
        <div className='itemNumber'>{dashboard[key]}</div>
        <div className='itemLabel'>{label}</div>
      </Paper>
    )
  }

  render() {
    const keys = this.props.keys
    const { dashboard, dashboardType } = this.props
    const params = DashboardGrid.getQueryParams(
      this.props.startDate,
      this.props.endDate
    )
    return (
      <div className='group'>
        {keys.map(key => {
          if (dashboard[key] > 0) {
            return (
              <Link
                style={linkStyle}
                to={DashboardGrid.getUrlFromKey(dashboardType, key, params)}
                key={key}
              >
                {DashboardGrid.getSingleGrid(dashboard, key)}
              </Link>
            )
          }
          return DashboardGrid.getSingleGrid(dashboard, key)
        })}
      </div>
    )
  }
}

DashboardGrid.propTypes = {
  dashboard: PropTypes.object,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  keys: PropTypes.array
}



/** WEBPACK FOOTER **
 ** ./src/containers/Dashboard/Grid/DashboardGrid.js
 **/